module.exports = __webpack_public_path__ + "img/preview-10.067f2ac2.png";